import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Donations, Props as WidgetProps } from './Donations';
import reduxConnectContainer from './Donations.container';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';

const DonationsEditForm = lazy(() =>
  import(/* webpackChunkName: "owner" */ './DonationsEditForm')
);

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);
class DonationsBox extends React.Component<
  WidgetProps & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      ...props
    } = this.props;

    return (
      <WidgetBox
        moduleId={props.moduleId}
        header={props.t!('widgets.donations.header')}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        widgetMenuRenderer={closeMenu => this.renderEditMenu(closeMenu)}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        confirmWidgetRemoval={true}
      >
        <Donations {...props} />
      </WidgetBox>
    );
  }

  renderEditMenu = closeMenu => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <DonationsEditForm moduleId={this.props.moduleId} close={closeMenu} />
      </Suspense>
    );
  };
}

export default enhance(DonationsBox) as React.ComponentType<{}>;
